import {
    faFacebookSquare,
    faGithubSquare,
    faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelopeSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import Typewriter from "typewriter-effect";
import myPic from "../../../images/my-pic.png";
import "./HeaderMain.css";

const HeaderMain = () => {
    return (
        <section className="ms-5 me-5 mt-5 mb-5 pb-5">
            <div className="row">
                <div className="col-md-6">
                    <h3>Hi, I am</h3>
                    <h1 className="name">Saurav Ghosh</h1>
                    <h4>
                        <Typewriter
                            options={{
                                strings: [
                                    "Front End Developer",
                                    "Programmer",
                                    "React Developer",
                                ],
                                autoStart: true,
                                loop: true,
                            }}
                        />
                    </h4>
                    <p className="mt-3">
                        I am a deep-heart javascript lover. I know some front
                        end and back end framework. Such as React Js, Bootstrap,
                        Node Js, Express Js and database mongoDB. In a word MERN
                        stack developer.{" "}
                    </p>
                    <div className="mt-5">
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.linkedin.com/in/saurav-ghosh-6a1ab0202/"
                        >
                            <FontAwesomeIcon
                                className="icon"
                                icon={faLinkedin}
                            />
                        </a>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://github.com/saurav-ghosh"
                        >
                            <FontAwesomeIcon
                                className="icon"
                                icon={faGithubSquare}
                            />
                        </a>
                        <Link to="/contact">
                            <FontAwesomeIcon
                                className="icon"
                                icon={faEnvelopeSquare}
                            />
                        </Link>
                        <FontAwesomeIcon
                            className="icon"
                            icon={faFacebookSquare}
                        />
                    </div>
                    <div className="mt-5">
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.linkedin.com/in/saurav-ghosh-6a1ab0202/"
                        >
                            <button className="button">Hire Me</button>
                        </a>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://drive.google.com/uc?export=download&id=1GBoBjUAedtPjHMDW3kgaK22Osk06nqmV"
                        >
                            <button className="button">Resume</button>
                        </a>
                    </div>
                </div>
                <div className="col-md-6 my-picture">
                    <img src={myPic} alt="" />
                </div>
            </div>
        </section>
    );
};

export default HeaderMain;
